import { Component } from '@angular/core';
import { PlayerSessionService } from '../services/player-session.service';
import { LibraryService } from '../services/library.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-results',
  templateUrl: './results.component.html',
  styleUrls: ['./results.component.scss'],
})
export class ResultsComponent {
  isLoading: any;
  sessions: any;
  allStats: any;
  libraryItems: any;
  filteredScenarios: any = [];
  filteredSessions: any = [];
  libraryItemHashMap: any = {};

  constructor(
    private playerSessionService: PlayerSessionService,
    private libraryService: LibraryService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.playerSessionService.clearCache();
    this.playerSessionService
      .fetchUserPlays()
      .subscribe((sessionsResponseData: any) => {
        this.sessions = sessionsResponseData;
        this.filteredSessions = this.sessions;
      });

    // get all stats
    this.playerSessionService
      .fetchAllStats()
      .subscribe((sessionStatsResponseData: any) => {
        this.isLoading = false;
        this.allStats = sessionStatsResponseData;
      });

    // get all the library items

    this.libraryService.fetchAll().subscribe((responseData) => {
      this.libraryItems = responseData;
      this.libraryItems.forEach((libraryItem: any) => {
        this.filteredScenarios.push(libraryItem.library_item_id);
        this.libraryItemHashMap[libraryItem.published_hash] =
          libraryItem.library_item_id;
      });
    });

    this.route.queryParams.subscribe((params) => {
      if (params['lid']) {
        this.isLoading = true;
        this.filteredScenarios = [];
        this.filteredScenarios.push(+params['lid']);
        setTimeout(() => {
          this.onApplyFilter();
          this.isLoading = false;
        }, 500);
      }
    });
  }

  onFilterScenario(libraryItemId: any) {
    let scenarioIndex = -1;

    this.filteredScenarios.forEach((_libraryItemId: any, index: number) => {
      if (_libraryItemId == libraryItemId) {
        scenarioIndex = index;
      }
    });

    if (scenarioIndex == -1) {
      // add
      this.filteredScenarios.push(libraryItemId);
    } else {
      // drop
      this.filteredScenarios.splice(scenarioIndex, 1);
    }
  }

  checkFilter(libraryItemId: any) {
    let scenarioIndex = -1;

    this.filteredScenarios.forEach((_libraryItemId: any, index: number) => {
      if (_libraryItemId == libraryItemId) {
        scenarioIndex = index;
      }
    });
    return scenarioIndex !== -1;
  }

  onApplyFilter() {
    this.filteredSessions = [];
    this.sessions.forEach((session: any) => {
      if (
        this.filteredScenarios.indexOf(
          this.libraryItemHashMap[session.hash],
        ) !== -1
      ) {
        this.filteredSessions.push(session);
      }
    });
  }
}
